export const translations = {
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    orders: 'الطلبات',
    users: 'المستخدمين',
    drivers: 'السائقين',
    cafes: 'المقاهي',
    categories: 'التصنيفات',
    reports: 'التقارير',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',

    // Common
    search: 'بحث...',
    filter: 'فلتر',
    export: 'تصدير',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    view: 'عرض',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    all: 'الكل',
    actions: 'إجراءات',

    // Stats
    todayOrders: 'طلبات اليوم',
    totalRevenue: 'إجمالي الإيرادات',
    totalUsers: 'المستخدمين',
    totalDrivers: 'السائقين',
    recentOrders: 'آخر الطلبات',
    pendingActions: 'إجراءات معلقة',

    // Status
    pending: 'قيد الانتظار',
    confirmed: 'مؤكد',
    preparing: 'جاري التحضير',
    ready: 'جاهز',
    onTheWay: 'في الطريق',
    delivered: 'تم التوصيل',
    cancelled: 'ملغي',
    active: 'نشط',
    suspended: 'موقوف',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    online: 'متصل',
    offline: 'غير متصل',

    // Table Headers
    orderNumber: 'رقم الطلب',
    customer: 'العميل',
    cafe: 'المقهى',
    driver: 'السائق',
    amount: 'المبلغ',
    status: 'الحالة',
    date: 'التاريخ',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    rating: 'التقييم',
    address: 'العنوان',

    // Settings
    theme: 'المظهر',
    language: 'اللغة',
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    arabic: 'العربية',
    english: 'English',

    // Currency
    egp: 'ج.م',

    // Time
    today: 'اليوم',
    yesterday: 'أمس',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',

    // Messages
    saveSuccess: 'تم الحفظ بنجاح',
    deleteSuccess: 'تم الحذف بنجاح',
    error: 'حدث خطأ',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
  },

  en: {
    // Navigation
    dashboard: 'Dashboard',
    orders: 'Orders',
    users: 'Users',
    drivers: 'Drivers',
    cafes: 'Cafes',
    categories: 'Categories',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Logout',

    // Common
    search: 'Search...',
    filter: 'Filter',
    export: 'Export',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    view: 'View',
    loading: 'Loading...',
    noData: 'No data available',
    all: 'All',
    actions: 'Actions',

    // Stats
    todayOrders: "Today's Orders",
    totalRevenue: 'Total Revenue',
    totalUsers: 'Total Users',
    totalDrivers: 'Total Drivers',
    recentOrders: 'Recent Orders',
    pendingActions: 'Pending Actions',

    // Status
    pending: 'Pending',
    confirmed: 'Confirmed',
    preparing: 'Preparing',
    ready: 'Ready',
    onTheWay: 'On the Way',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    active: 'Active',
    suspended: 'Suspended',
    approved: 'Approved',
    rejected: 'Rejected',
    online: 'Online',
    offline: 'Offline',

    // Table Headers
    orderNumber: 'Order #',
    customer: 'Customer',
    cafe: 'Cafe',
    driver: 'Driver',
    amount: 'Amount',
    status: 'Status',
    date: 'Date',
    phone: 'Phone',
    email: 'Email',
    rating: 'Rating',
    address: 'Address',

    // Settings
    theme: 'Theme',
    language: 'Language',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    arabic: 'العربية',
    english: 'English',

    // Currency
    egp: 'EGP',

    // Time
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    thisMonth: 'This Month',

    // Messages
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    error: 'An error occurred',
    confirmDelete: 'Are you sure you want to delete?',
  },
} as const;

export type TranslationKey = keyof typeof translations.ar;
